(($)=>{

	const blockRootSelector = '.icon-blocks.slider-on-mobile';
	const blockName = 'blockIconBlocks';

	/// All logic and initialization is inside this function.
	function initializeBlock(el){

		const $slickEl = $('.row', el);
		// if( window.innerWidth < 560 ) {
			$slickEl.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: true,
				mobileFirst: true,
				responsive: [
					{
						breakpoint: 768,
						settings: "unslick" // destroys slick
					}
				]
			});
		// }

		// return  element so later it'll not be reinitialized
		return el;
	}


	//we initialize blocks of this type which are already rendered on page not via ajax.
	$(blockRootSelector).each((index, el) => {

		const blockId = `wpshopify_initial_${blockName}_${index}`;

		window.WPShopify.blockInstances[blockId] = {
			el: el,
			id: blockId,
			blockInitFunctionName: blockName,
			instance: initializeBlock(el)
		};

	});

	// save our block initializer function to storage to make it possible to init blocks of same type loaded by ajax.
	window.WPShopify.blocksInits[blockName] = initializeBlock;


})(jQuery);



// (function($) {
//
// 	var $iconBlockSlider = $('');
//
// 	if ( $iconBlockSlider.length ) {
//
// 		function iconBlockSlider() {
//
// 		}
//
// 		if( window.innerWidth < 560 ) {
// 			iconBlockSlider();
// 		}
//
// 		// $(window).resize(function(event) {
//
// 		// 	if ( window.innerWidth < 560 ) {
// 		// 		if ( !$iconBlockSlider.hasClass('.slick-initialized') ) {
// 		// 			iconBlockSlider();
// 		// 		}
// 		// 	} else {
// 		// 		if ( $iconBlockSlider.hasClass('.slick-initialized') ) {
// 		// 			$iconBlockSlider.slick('unslick');
// 		// 		}
// 		// 	}
//
// 		// });
//
// 	}
//
// })(jQuery);